import { createSlice } from '@reduxjs/toolkit';
import { notifyUserError } from 'utils/notifications';

import { deleteFile, getFiles, getFilesPreview, putFile, FilesItem } from './filesActions';

type InitialState = {
  filesList: {
    content: FilesItem[];
    page: number;
    size: number;
    sorts: { title: string; direction: string }[] | null;
  };
  filesListLoading: boolean;
  filesPreviewList: FilesItem[];
  filesPreviewListLoading: boolean;
};

const initialState: InitialState = {
  filesList: {
    content: [],
    page: 0,
    size: 99999,
    sorts: null
  },
  filesListLoading: false,
  filesPreviewList: [],
  filesPreviewListLoading: false
};

export const filesSlice = createSlice({
  name: 'filesSlice',
  initialState,
  reducers: {
    updateSortsList: (state, action) => {
      state.filesList.sorts = action.payload;
    },
    resetFilesList: (state) => {
      state.filesListLoading = false;
      state.filesList.content = [];
      state.filesList.sorts = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFiles.pending, (state, action) => {
        state.filesListLoading = true;
      })
      .addCase(getFiles.fulfilled, (state, { payload }: any) => {
        state.filesList.content = payload.content ?? [];
        state.filesList.page = payload.page ?? 0;
        state.filesList.size = payload.size ?? initialState.filesList.size;
        state.filesList.sorts = payload.sorts ?? null;
        state.filesListLoading = false;
      })
      .addCase(getFiles.rejected, (state, { payload }: any) => {
        state.filesListLoading = false;
        notifyUserError(payload);
      })
      .addCase(getFilesPreview.pending, (state, action) => {
        state.filesPreviewListLoading = true;
      })
      .addCase(getFilesPreview.fulfilled, (state, { payload }: any) => {
        state.filesPreviewList = payload;
        state.filesPreviewListLoading = false;
      })
      .addCase(getFilesPreview.rejected, (state, { payload }: any) => {
        state.filesPreviewListLoading = false;
        notifyUserError(payload);
      })
      .addCase(putFile.fulfilled, (state, { payload }: any) => {
        const index = state.filesList.content.findIndex((a) => a.id === payload.data?.id);
        if (index !== -1) {
          state.filesList.content[index] = { ...payload.data };
        }
      })
      .addCase(putFile.rejected, (_, { payload }: any) => {
        notifyUserError('Failed to update file name.');
      })
      .addCase(deleteFile.fulfilled, (state, { payload }: any) => {
        const index = state.filesList.content.findIndex((a) => a.id === payload);
        if (index !== -1) {
          state.filesList.content.splice(index, 1);
        }
      })
      .addCase(deleteFile.rejected, (_, { payload }: any) => {
        notifyUserError(payload);
      });
  }
});

export const { updateSortsList, resetFilesList } = filesSlice.actions;
export default filesSlice.reducer;
